import * as React from "react";

import {
	Button,
	Box,
	FormControl,
	Grid,
	Typography,
	IconButton,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const AdvanceForm = () => {
	return (
		<form style={{ padding: "0 2%", backgroundColor: "#FFFFFF" }}>
			<Box
				sx={{ display: "flex", alignItems: "center", padding: "30px 0 10px 0" }}
			>
				<Typography
					sx={{
						fontWeight: "600",
						fontSize: "15.71px",
						lineHeight: "22px",
						color: "#09797A ",
					}}
				>
					Advance Search
				</Typography>
				<IconButton aria-label="info">
					<HelpOutlineIcon
						sx={{
							color: "#3ED9C4",
							textTransform: "capitalize",
							fontWeight: "500",
							fontSize: "10.5992px",
							lineHeight: "20px",
							boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.07)",
							borderRadius: "50%",
							width: "20px",
							height: "20px",
						}}
					/>
				</IconButton>
			</Box>
			<Grid container spacing={3} justifyContent="center" alignItems="center">
				<Grid item xs={12} sm={4} md={2.4}>
					<Box className="advance__form__small__control">
						<label>LGA</label>
						<input className="advance__form__small__input" />
					</Box>
				</Grid>
				<Grid item xs={12} sm={4} md={2.4}>
					<Box className="advance__form__small__control">
						<label>Year</label>
						<input className="advance__form__small__input" />
					</Box>
				</Grid>
				<Grid item xs={12} sm={4} md={2.4}>
					<Box className="advance__form__small__control">
						<label>Contractor</label>
						<input className="advance__form__small__input" />
					</Box>
				</Grid>
				<Grid item xs={12} sm={4} md={2.4}>
					<Box className="advance__form__small__control">
						<label>MDA</label>
						<input className="advance__form__small__input" />
					</Box>
				</Grid>
				<Grid item xs={12} sm={4} md={2.4}>
					<Box className="advance__form__small__control">
						<label>Status</label>
						<input className="advance__form__small__input" />
					</Box>
				</Grid>
			</Grid>
			<Grid
				container
				my={3}
				spacing={3}
				justifyContent="center"
				alignItems="center"
			>
				<Grid item xs={12} sm={5}>
					<FormControl fullWidth>
						<Box className="advance__form__small__control">
							<label>Procurement Category</label>
							<select className="advance__form__select__input">
								<option selected>
									<em></em>
								</option>
								<option value="">option one</option>
								<option value="">option two</option>
								<option value="">option three</option>
								<option value="">option four</option>
							</select>
						</Box>
					</FormControl>
				</Grid>
				<Grid item xs={12} sm={5}>
					<FormControl fullWidth>
						<Box className="advance__form__small__control">
							<label>Procurement Method</label>
							<select className="advance__form__select__input">
								<option selected>
									<em></em>
								</option>
								<option value="">option one</option>
								<option value="">option two</option>
								<option value="">option three</option>
								<option value="">option four</option>
							</select>
						</Box>
					</FormControl>
				</Grid>
				<Grid item xs={6} sm={2}>
					<Button
						variant="contained"
						disableElevation
						sx={{
							padding: "10px 25px",
							margin: "20px auto 0",
							backgroundColor: "#03C6C8",
							"&:hover": {
								cursor: "pointer",
								backgroundColor: "#8C8585",
							},
						}}
					>
						Search
					</Button>
				</Grid>
			</Grid>
		</form>
	);
};
